function RefreshIcon({ color = "currentColor", className, style }) {
  return (
    <svg width={42} height={41} viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} style={{ color, ...style }}>
      <path d="M2.333 20.25C2.333 9.94 10.691 1.583 21 1.583c5.95 0 11.248 2.783 14.667 7.119m4 11.548c0 10.31-8.358 18.667-18.667 18.667-5.95 0-11.249-2.784-14.667-7.119m8-.881H5v9.333m32-40v9.333h-9.333" stroke="currentColor" strokeWidth={3} />
    </svg>
  );
}
export default RefreshIcon;
